module.exports = __webpack_public_path__ + "img/796.9590d816.jpg";